/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} OrdersInputs */

const en_orders = /** @type {(inputs: OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orders`)
};

const es_orders = /** @type {(inputs: OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pedidos`)
};

const fr_orders = /** @type {(inputs: OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commandes`)
};

const de_orders = /** @type {(inputs: OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestellungen`)
};

const ja_orders = /** @type {(inputs: OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`注文`)
};

const zh_orders = /** @type {(inputs: OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`订单`)
};

const ar_orders = /** @type {(inputs: OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الطلبات`)
};

const id_orders = /** @type {(inputs: OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesanan`)
};

const it_orders = /** @type {(inputs: OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordini`)
};

const ru_orders = /** @type {(inputs: OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заказы`)
};

const pt_orders = /** @type {(inputs: OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pedidos`)
};

const ko_orders = /** @type {(inputs: OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`주문`)
};

/**
* | output |
* | --- |
* | "Orders" |
*
* @param {OrdersInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const orders = /** @type {((inputs?: OrdersInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<OrdersInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders(inputs)
	if (locale === "es") return es_orders(inputs)
	if (locale === "fr") return fr_orders(inputs)
	if (locale === "de") return de_orders(inputs)
	if (locale === "ja") return ja_orders(inputs)
	if (locale === "zh") return zh_orders(inputs)
	if (locale === "ar") return ar_orders(inputs)
	if (locale === "id") return id_orders(inputs)
	if (locale === "it") return it_orders(inputs)
	if (locale === "ru") return ru_orders(inputs)
	if (locale === "pt") return pt_orders(inputs)
	return ko_orders(inputs)
});